import Vue from 'vue';
import Router from 'vue-router';
import Header from '@/components/header';
import Product from '@/components/product_content';
import Home from '@/components/main';
import Contact from '@/components/contact-content';
import About from '@/components/about-content';
import Partners from '@/components/partners-content';
import System_scheme from '@/components/system-scheme-content';
import writePlan from '@/components/writePlan.vue';
import showPlan from '@/components/showPlan.vue';
import manageProducts from '@/components/manage_products.vue';
import showProduct from '@/components/showProduct.vue';
import Admin from '@/components/admin.vue';
import UE from '@/components/UE.vue';
import PlansManage from '@/components/plans_manage.vue';
import ProductManage from '@/components/products_manage.vue';
import Login from '@/components/login.vue';
import CarouselManage from '@/components/carouse_manage.vue';
import AboutManage from '@/components/about_manage.vue';
import PhoneManage from '@/components/phone_manage.vue';
import PartnerManage from '@/components/partner_manage.vue';
import FootManage from '@/components/foot_manage.vue';
import Notfount from '@/components/notfount.vue';

Vue.use(Router);

export default new Router({
  /** 注意：name定义为中文的为导航栏，主要用于刷新页面，自动定位那个导航栏为选中状态 */
  routes: [{
      path: '/',
      name: '首页',
      component: Home
    },
    {
      path: "/header",
      name: "header",
      component: Header,
      beforeEnter: function () {}
    },
    {
      path: "/product",
      name: '产品中心',
      component: Product,
    },
    {
      path: '/home',
      name: '首页',
      component: Home,
    },
    {
      path: '/contact',
      name: "联系我们",
      component: Contact
    },
    {
      path: "/about",
      name: '关于金界',
      component: About
    },
    {
      path: "/partners",
      name: '合作伙伴',
      component: Partners,
    },
    {
      path: '/system_scheme',
      name: "系统方案",
      component: System_scheme
    },
    {
      path: '/system_scheme/:id',
      name: '系统方案',
      component: showPlan
    },
    {
      path: '/product/:pro_id',
      name: '产品中心',
      component: showProduct
    },
    {
      path: "/write",
      name: 'write',
      component: writePlan,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/manageProducts',
      name: 'manageProducts',
      component: manageProducts,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: {
        requireAuth: true
      },
      children: [{
        path: 'UE/:id',
        component: UE,
        meta: {
          requireAuth: true
        },
        props: true
      }, {
        path: "planmanage",
        component: PlansManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: "productmanage",
        component: ProductManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: 'carousel',
        component: CarouselManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: "aboutmanage",
        component: AboutManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: "phonemanage",
        component: PhoneManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: "partnermanage",
        component: PartnerManage,
        meta: {
          requireAuth: true
        }
      }, {
        path: "footmanage",
        component: FootManage,
        meta: {
          requireAuth: true
        }
      }]
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "*",
      component: Notfount
    }
  ],
  mode: 'history',
  base: "/"
})



// WEBPACK FOOTER //
// ./src/router/index.js